import { render, staticRenderFns } from "./PolygonMap.vue?vue&type=template&id=8456719c&scoped=true"
import script from "./PolygonMap.vue?vue&type=script&lang=js"
export * from "./PolygonMap.vue?vue&type=script&lang=js"
import style0 from "./PolygonMap.vue?vue&type=style&index=0&id=8456719c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8456719c",
  null
  
)

export default component.exports